import React, { useEffect, useState } from 'react';
import Profile from '../components/Account/Profile';
import Preferences from '../components/Account/Preferences';
import SubscriptionStatus from '../components/Account/SubscriptionStatus';
import CertificateModal from '../components/Login/CertificateModal';
import { userEvents } from '../utils/analytics';
import './Account.css';

function Account() {
  const [showCertificateModal, setShowCertificateModal] = useState(false);

  useEffect(() => {
    userEvents.pageView('account', { type: 'protected' });
    
    // Check if we should show certificate modal (set during login)
    const shouldShow = sessionStorage.getItem('showCertificate');
    if (shouldShow === 'true') {
      // Timer disabled - show modal immediately
      setShowCertificateModal(true);
      
      // Check if 24 hours have passed since last certificate show (DISABLED)
      //const lastCertificateTime = localStorage.getItem('lastCertificateTime');
      //const now = Date.now();
      //const twentyFourHours = 24 * 60 * 60 * 1000; // 24 hours in milliseconds
      //if (!lastCertificateTime || (now - parseInt(lastCertificateTime)) >= twentyFourHours) {
      //  localStorage.setItem('lastCertificateTime', now.toString());
      //}
      
      // Clear the sessionStorage flag regardless
      sessionStorage.removeItem('showCertificate');
    }
  }, []);

  const handleCertificateModalClose = () => {
    setShowCertificateModal(false);
  };

  return (
    <div className="account">
      <div className="account-cards">
        <Profile />
        <SubscriptionStatus />
      </div>
      <Preferences />
      {showCertificateModal && (
        <CertificateModal 
          isOpen={showCertificateModal}
          onClose={handleCertificateModalClose}
        />
      )}
    </div>
  );
}

export default Account;
